<template>
  <header class="article-heading" data-testid="blog-heading">
    <NuxtLink v-if="editorial" to="/blog" class="editorial-text-link article-back">
      ← Back to the blog
    </NuxtLink>
    <h1 data-testid="article-title">{{ title }}</h1>
    <p v-if="description" class="article-dek">{{ description }}</p>
    <div v-if="editorial || date" class="article-byline">
      <BlogInfo
        :date="date"
        :reading-time="readingTime"
        :cypress-version="cypressVersion"
        :playwright-version="playwrightVersion"
        :vitest-version="vitestVersion"
        :webdriverio-version="webdriverioVersion"
        :cursor-version="cursorVersion"
      />
    </div>
    <div v-if="image" class="article-heading-image"><Image :src="image" :alt="title" /></div>
  </header>
</template>
<script setup lang="ts">
defineProps<{
  editorial?: boolean
  date?: string
  title?: string
  description?: string
  image?: string
  readingTime?: string
  cypressVersion?: string
  playwrightVersion?: string
  vitestVersion?: string
  webdriverioVersion?: string
  cursorVersion?: string
}>()
</script>
